import { ValveClosed, ValveError, ValveOpen, ValveUnknown } from '../data-icons/valve-icons'

const ValvePositionBubble = ({ value, isOffline }: { value: string; isOffline: boolean }) => {
  const offlineText = isOffline ? ' (Offline)' : ''

  const { ariaLabel, IconComponent } = {
    open: { ariaLabel: 'Open', IconComponent: ValveOpen },
    closed: { ariaLabel: 'Closed', IconComponent: ValveClosed },
    error: { ariaLabel: 'Error', IconComponent: ValveError },
    unknown: { ariaLabel: 'Unknown', IconComponent: ValveUnknown },
  }[value] ?? { ariaLabel: 'Unknown', IconComponent: ValveUnknown }

  return <IconComponent ariaLabel={`${ariaLabel}${offlineText}`} />
}

export default ValvePositionBubble
